import React, { createContext, useContext, useEffect, useState } from "react";

const BaseContext = createContext(null);

const STORAGE_KEY = "chemwms_active_base";

export function BaseProvider({ children }) {
  const [activeBase, setActiveBaseState] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null; // {code, name}
    } catch {
      return null;
    }
  });

  useEffect(() => {
    if (activeBase) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(activeBase));
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  }, [activeBase]);

  const setActiveBase = (base) => setActiveBaseState(base ? { code: base.code, name: base.name } : null);
  const clearActiveBase = () => setActiveBaseState(null);

  return (
    <BaseContext.Provider value={{ activeBase, setActiveBase, clearActiveBase }}>
      {children}
    </BaseContext.Provider>
  );
}

export const useActiveBase = () => useContext(BaseContext);
